export default [
    {
        path: "/profiles",
        name: "profiles",
        component: () => import("@/view/profile/ProfileDashboard.vue"),
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: ":barcode",
                name: "profile-view",
                component: () => import("@/view/profile/ProfileView.vue"),
            },
            {
                path: "/profiles/edit-account-info",
                name: "edit-account-info",
                component: () => import("@/view/profile/EditAccountInfo.vue")
            },
            {
                path: "add-profile",
                name: "add-profile",
                component: () => import("@/view/profile/AddProfileSection.vue")
            },
            {
                path: "upload/who-does-this-dna-belong-to",
                name: "profile-who-does-this-dna-belong-to",
                component: () => import("@/view/profile/upload/WhoDoesThisDnaBelongTo.vue"),
            },
            {
                path: "upload/upload-dna",
                name: "profile-upload-dna",
                component: () => import("@/view/profile/upload/UploadDnaFile.vue"),
            },
            {
                path: "upload/complete",
                name: "profile-upload-complete",
                component: () => import("@/view/profile/upload/UploadComplete.vue"),
            },
            {
                path: "upload/family-networks-opt-in",
                name: "profile-upload-family-networks-opt-in",
                component: () => import("@/view/profile/FamilyNetworks/OptIn.vue"),
            },
            {
                path: "upload/family-networks-username",
                name: "profile-upload-family-networks-username",
                component: () => import("@/view/profile/FamilyNetworks/AddUsername.vue"),
            },
            {
                path: "upload/family-networks-avatar",
                name: "profile-upload-family-networks-avatar",
                component: () => import("@/view/profile/FamilyNetworks/AddAvatar.vue"),
            },

            {
                path: "family-networks-opt-in",
                name: "profile-family-networks-opt-in",
                component: () => import("@/view/profile/FamilyNetworks/OptIn.vue"),
            },
            {
                path: "family-networks-username",
                name: "profile-family-networks-username",
                component: () => import("@/view/profile/FamilyNetworks/AddUsername.vue"),
            },
            {
                path: "family-networks-avatar",
                name: "profile-family-networks-avatar",
                component: () => import("@/view/profile/FamilyNetworks/AddAvatar.vue"),
            },


            {
                path: "activate-health-kit",
                name: "profile-activate-health-kit",
                component: () => import("@/view/profile/HealthKitActivation/EnterHealthKitCode.vue"),
            },
            {
                path: "activate-health-kit/todo",
                name: "profile-activate-health-kit-todo",
                component: () => import("@/view/profile/HealthKitActivation/ThingsYouNeedToDo.vue"),
            },
            {
                path: "activate-health-kit/details",
                name: "profile-activate-health-kit-details",
                component: () => import("@/view/profile/HealthKitActivation/ActivationDetails.vue"),
            },
            {
                path: "activate-health-kit/success",
                name: "profile-activate-health-kit-success",
                component: () => import("@/view/profile/HealthKitActivation/ActivationSuccess.vue"),
            },
            {
                path: "activate-health-kit/questionnaire-completed",
                name: "profile-activate-health-kit-questionnaire-completed",
                component: () => import("@/view/profile/HealthKitActivation/QuestionnaireCompleted.vue")
            },


            // Activate DNA Kit
            {
                path: "activate-dna-kit",
                name: "profile-activate-dna-kit",
                component: () => import("@/view/profile/DnaKitActivation/EnterDnaKitCode.vue"),
            },
            {
                path: "who-is-this-kit-for",
                name: "profile-who-is-this-kit-for",
                component: () => import("@/view/profile/DnaKitActivation/WhoIsThisKitFor.vue")
            },
            {
                path: "activation-completed",
                name: "profile-activation-completed",
                component: () => import("@/view/profile/DnaKitActivation/ActivationCompleted.vue")
            },
            {
                path: ":barcode/download",
                name: "download-raw-data",
                component: () => import("@/view/profile/DownloadRawData.vue"),
            },
            {
                path: ":barcode/edit-personal-info",
                name: "edit-personal-info",
                component: () => import("@/view/profile/EditPersonalInformation.vue")
            },
            {
                path: ":barcode/edit-family-matching",
                name: "edit-family-matching",
                component: () => import("@/view/profile/EditFamilyMatching.vue")
            },
            {
                path: ":barcode/edit-profile-manager",
                name: "edit-profile-manager",
                component: () => import("@/view/profile/AddProfileManager.vue")
            },
            {
                path: ":barcode/edit-profile-photo",
                name: "edit-profile-photo",
                component: () => import("@/view/profile/EditProfilePhoto.vue")
            },
            {
                path: ":barcode/delete-profile",
                name: "delete-profile",
                component: () => import("@/view/profile/DeleteProfile/DeleteProfile.vue"),
            },
            {
                path: ":barcode/request-profile-deletion",
                name: "request-profile-deletion",
                component: () => import("@/view/profile/DeleteProfile/RequestDeletion.vue"),
            },
            {
                path: ":barcode/confirm-profile-deletion",
                name: "confirm-profile-deletion",
                component: () => import("@/view/profile/DeleteProfile/ConfirmDeletion.vue"),
            },
            {
                path: ":barcode/research",
                name: "research",
                component: () => import("@/view/profile/ResearchPage.vue"),
            },
            {
                path: ":barcode/health",
                name: "profile-health",
                component: () => import("@/view/profile/Health/HealthDetails.vue"),
                meta: {
                    requiresHealth: true
                }
            },
            {
                path: ":barcode/health",
                name: "health-profile",
                component: () => import("@/view/profile/Health/HealthDetails.vue"),
                meta: {
                    requiresHealth: true
                }
            },
            {
                path: "delete-account",
                name: "delete-account",
                component: () => import("@/view/profile/DeleteAccount/DeleteAccount.vue"),
            },
            {
                path: "request-account-deletion",
                name: "request-account-deletion",
                component: () => import("@/view/profile/DeleteAccount/RequestDeletion.vue"),
            },
            {
                path: "confirm-account-deletion",
                name: "confirm-account-deletion",
                component: () => import("@/view/profile/DeleteAccount/ConfirmDeletion.vue"),
            },
            {
                path: "/profile/:barcode/upload/reupload-dna",
                component: () => import("@/view/profile/upload/ReuploadDna.vue"),
                name: "reupload-dna",
            },
        ],
    },
    {
        path: "/share/:uuid",
        name: "share-profile",
        component: () => import("@/view/profile/Sharing/PublicProfile.vue")
    }
];
